import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tickets",
  "use": "icon-tickets-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tickets\">\n<g id=\"icon-tickets_Frame\">\n<path id=\"icon-tickets_Vector\" d=\"M24 0H0V24H24V0Z\" fill=\"white\" fill-opacity=\"0.01\" />\n<path id=\"icon-tickets_Vector_2\" d=\"M19 3.5H5V20.5H19V3.5Z\" stroke=\"#909399\" stroke-width=\"1.5\" stroke-linejoin=\"round\" />\n<path id=\"icon-tickets_Vector_3\" d=\"M9 9.5H15\" stroke=\"#909399\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path id=\"icon-tickets_Vector_4\" d=\"M9 13.5H15\" stroke=\"#909399\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tickets.svg
// module id = IOs2
// module chunks = 45